// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "domtour/theme/workation/music/js/" + chunkId + "." + "bac2cdd8" + ".chunk.js";
};